/* eslint-disable react-hooks/exhaustive-deps */

import {useMutation, useQuery} from "@apollo/react-hooks";
import {makeStyles} from '@material-ui/core/styles';
import React, {useCallback, useEffect, useState} from 'react';
import {
    CREATE_MAIL_ADDRESS,
    DELETE_MAIL_ADDRESS,
    GET_MAIL_ADDRESSES_OF_PARENT,
    UPDATE_MAIL_ADDRESS
} from "../../database/queries/mailAddressQueries";
import MaterialTable, {MTableEditField} from "material-table";
import Autocomplete from 'react-google-autocomplete';
import tableIcons from "../../constants/tableIcons";
import {SizeMe} from "react-sizeme";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import {addressComponentsFromGoogle, simulateMouseClick} from "../../utils/utils";
import usePersistentStore from "../../persistentStore";
import ChooseFromChoices from "./chooseFromChoices";
import {MAIL_ADDRESS_TYPE_CHOICES} from "../../database/queries/enumQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    googleOK: {},
    googleNotOK: {
        borderColor: 'red',
    }
}));

const MailAddresses = props => {
    const classes = useStyles();
    const [globalLayoutState] = useLayoutStore();
    const [globalPersistentState] = usePersistentStore();
    const [editedMailAddress, setEditedMailAddress] = useState();
    const [editedMailAddressType, setEditedMailAddressType] = useState('office');
    const [addresses, setAddresses] = useState([]);

    const {loading: getMailAddressesOfParentLoading, error: getMailAddressesOfParentError, data: getMailAddressesOfParentData, refetch: getMailAddressesOfParentRefetch} = useQuery(GET_MAIL_ADDRESSES_OF_PARENT, {
        skip: !props.editId || props.editId === 'new',
        variables: {
            parentType: props.editType,
            parentId: props.editId,
        },
    });

    const [createMailAddress, {error: createMailAddressError}] = useMutation(CREATE_MAIL_ADDRESS);
    const [updateMailAddress, {error: updateMailAddressError}] = useMutation(UPDATE_MAIL_ADDRESS);
    const [deleteMailAddress, {error: deleteMailAddressError}] = useMutation(DELETE_MAIL_ADDRESS);

    const columns = [
        {title: 'Address', field: 'fullAddress', width: '65%'},
        {title: 'Type', field: 'mailAddressType', width: '25%'},
        {title: 'Primary', field: 'primary', type: 'boolean', width: '10%'},
    ];

    const components = {
        EditField: efprops => {
            if (efprops.columnDef.field === 'fullAddress') {
                let value = efprops.value;
                if (!value && editedMailAddress) value = editedMailAddress.fullAddress;
                return (
                    <Autocomplete
                        style={{width: '90%'}}
                        className={editedMailAddress && editedMailAddress.googleId ? classes.googleOK : classes.googleNotOK}
                        autoFocus
                        onPlaceSelected={(place) => {
                            const addr = addressComponentsFromGoogle(place);
                            setEditedMailAddress(addr);
                            return addr;
                        }}
                        // onChange={(y) => {
                        //     setEditedMailAddress({...editedMailAddress, fullAddress: y.target.value})
                        // }}
                        types={['address']}
                        fields={['place_id', 'address_component', 'formatted_address']}
                        defaultValue={value}
                    />
                )
            } else if (efprops.columnDef.field === 'mailAddressType') {
                let value = efprops.value;
                if (!value && editedMailAddressType) value = editedMailAddressType;
                return (
                    <ChooseFromChoices
                        choicesQuery={MAIL_ADDRESS_TYPE_CHOICES}
                        required={true}
                        value={value}
                        onChange={(newMailAddressType) => {
                            setEditedMailAddressType(newMailAddressType);
                            return newMailAddressType;
                        }}
                    />
                )
            } else {
                return (<MTableEditField {...efprops} />);
            }
        },
    };

    useEffect(() => {
        if (createMailAddressError) notify('createMailAddressError', 'error', createMailAddressError.message, null, null, globalPersistentState.popupQueryObj);
        if (deleteMailAddressError) notify('deleteMailAddressError', 'error', deleteMailAddressError.message, null, null, globalPersistentState.popupQueryObj);
        if (getMailAddressesOfParentError) notify('getMailAddressesOfParentError', 'error', getMailAddressesOfParentError.message, null, null, globalPersistentState.popupQueryObj);
        if (updateMailAddressError) notify('updateMailAddressError', 'error', updateMailAddressError.message, null, null, globalPersistentState.popupQueryObj);
    }, [createMailAddressError, deleteMailAddressError, getMailAddressesOfParentError, updateMailAddressError]);

    useEffect(() => {
        getMailAddressesOfParentRefetch();
    }, [getMailAddressesOfParentRefetch]);

    useEffect(() => {
    }, [globalLayoutState.editTabBarHeight]);

    useEffect(() => {
        if (getMailAddressesOfParentData && getMailAddressesOfParentData.mailAddressesOfParent) {
            let updatedAddresses = [];
            for (let ma = 0; ma < getMailAddressesOfParentData.mailAddressesOfParent.length; ma++) {
                let addr = getMailAddressesOfParentData.mailAddressesOfParent[ma];
                if (!addr.fullAddress || addr.fullAddress.length === 0) {
                    addr.fullAddress = '';
                    if (addr.address1) addr.fullAddress = addr.address1 + ', ';
                    if (addr.address2) addr.fullAddress += addr.address2 + ', ';
                    if (addr.city) addr.fullAddress += addr.city + ', ';
                    if (addr.state) addr.fullAddress += addr.state + ', ';
                    if (addr.postalCode) addr.fullAddress += addr.postalCode + ', ';
                    if (addr.country) addr.fullAddress += addr.country;
                }
                updatedAddresses.push(addr);
            }
            setAddresses(updatedAddresses)
        }
    }, [getMailAddressesOfParentData]);

    const tableCallback = useCallback(node => {
        const addBtn = document.querySelector('button[title="Add"]')
        if (addBtn && globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionText) {
            const mailAddress = globalPersistentState.popupQueryObj.selectionText;

            if (mailAddress.length > 0) {
                setEditedMailAddress({fullAddress: mailAddress});
                simulateMouseClick(addBtn);
            }
        }
    }, []);

    if (getMailAddressesOfParentLoading) return <p>Loading ...</p>;
    if (getMailAddressesOfParentError) return `Error! ${getMailAddressesOfParentError.message}`;

    return (
        <div className={classes.root}>
            {addresses && (
                <div>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;
                            const fudge = 10;

                            const tableOptions = {
                                maxBodyHeight: height - (globalLayoutState.editTabBarHeight + fudge),
                                padding: 'dense',
                                addRowPosition: 'first',
                                header: true,
                                paging: false,
                                showTitle: true,
                                search: false,
                                sorting: true,
                                actionsColumnIndex: -1
                            };

                            return (
                                <div ref={tableCallback}>
                                    <MaterialTable
                                        icons={tableIcons}
                                        title={`Mail Addresses ${props.editObj ? 'of ' + props.editObj.displayName : ''}`}
                                        columns={columns}
                                        data={addresses}
                                        options={tableOptions}
                                        components={components}
                                        editable={{
                                            onRowAdd: newData =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        let newMailAddress = {
                                                            ...newData,
                                                            ...editedMailAddress,
                                                            mailAddressType: editedMailAddressType,
                                                        };
                                                        newMailAddress.parentType = props.editType;
                                                        newMailAddress.parentId = props.editId;
                                                        newMailAddress.primary = (newData.primary === true);

                                                        let variables = {
                                                            newMailAddress: newMailAddress
                                                        };
                                                        createMailAddress({
                                                            variables: variables
                                                        }).then(createResult => {
                                                            getMailAddressesOfParentRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            reject();
                                                        });
                                                        resolve()
                                                    }, 1000);
                                                }),
                                            onRowUpdate: (newData, oldData) =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        let changedMailAddress = {...editedMailAddress};
                                                        changedMailAddress.mailAddressId = oldData.mailAddressId;
                                                        changedMailAddress.primary = newData.primary;
                                                        changedMailAddress.mailAddressType = editedMailAddressType ? editedMailAddressType : oldData.mailAddressType;

                                                        let variables = {
                                                            changedMailAddress: changedMailAddress
                                                        };
                                                        updateMailAddress({
                                                            variables: variables
                                                        }).then(updateResult => {
                                                            getMailAddressesOfParentRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            console.trace(e);
                                                            reject();
                                                        });
                                                        resolve()
                                                    }, 1000)
                                                }),
                                            onRowDelete: oldData =>
                                                new Promise((resolve, reject) => {
                                                    setTimeout(() => {
                                                        deleteMailAddress({
                                                            variables: {
                                                                deleteMailAddressId: oldData.mailAddressId,
                                                            }
                                                        }).then(() => {
                                                            getMailAddressesOfParentRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            reject();
                                                        });
                                                        resolve()
                                                    }, 1000)
                                                }),
                                        }}
                                    />
                                </div>
                            );
                        }}
                    </SizeMe>
                </div>
            )}
        </div>
    )
};

export default MailAddresses
